import LOCALS from 'commons/locals';
import i18n from 'i18n';

const RAW_MEMBER_LEVEL_MAP = {
  BRONZE: 'BRONZE',
  SILVER: 'SILVER',
  GOLD: 'GOLD',
  PLATINUM: 'PLATINUM',
} as const;

type MemberLevel =
  (typeof RAW_MEMBER_LEVEL_MAP)[keyof typeof RAW_MEMBER_LEVEL_MAP];

export const isMemberLevel = (value: string): value is MemberLevel => {
  return Object.values(RAW_MEMBER_LEVEL_MAP).includes(value as MemberLevel);
};

export const MEMBER_LEVEL_MAP = new Proxy(RAW_MEMBER_LEVEL_MAP, {
  ownKeys() {
    throw new Error(
      '❌ 禁止遍历 MEMBER_LEVEL_MAP！请直接通过属性精准获取值，如 MEMBER_LEVEL_MAP.BRONZE',
    );
  },
});

export const MEMBER_LEVEL_OPTION_LIST = Object.entries(
  RAW_MEMBER_LEVEL_MAP,
).map(([_, value]) => ({
  value,
  label: value,
}));

export const GENDER_MAP = {
  UNKNOW: 0,
  FEMALE: 1,
  MALE: 2,
};

export const GENDER_OPTION_LIST = [
  {
    value: GENDER_MAP.UNKNOW,
    label: i18n.t(LOCALS.rather_not_say),
  },
  {
    value: GENDER_MAP.FEMALE,
    label: i18n.t(LOCALS.female),
  },
  { value: GENDER_MAP.MALE, label: i18n.t(LOCALS.male) },
];
